// import { OfficesService } from '@/services/api/franchises.service';
import { Franchise } from '@/models/franchise.model';
import { PlansService } from '@/services/api/plans.service';
import { HttpClient } from '@angular/common/http';
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { tap } from 'rxjs';
import { Assembly } from 'src/app/models/assembly.model';
import { StandardTemplate } from 'src/app/models/standard-template.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OfficeTemplatesService {

  private http = inject(HttpClient);
  // private officeService = inject(OfficesService);
  private plansService = inject(PlansService);


  selectedTemplate = signal<StandardTemplate | null>(null);
  // private templates = signal<StandardTemplate[]>([]);

  public opsTemplates = signal<StandardTemplate[]>([]);

  public binderTemplates = signal<StandardTemplate[]>([]);

  filteredOpsTemplates = signal<StandardTemplate[]>([]);

  filteredBinderTemplates = signal<StandardTemplate[]>([]);

  officeFilter = signal<Franchise | null>(null);

  // addAssembliesVisible = signal<boolean>(false);

  BASEURL = environment.landmark_API_URL + '/standards';

  constructor() {
    effect(() => {
      const plan = this.plansService.selectedPlan();
      if(plan) {
        this.filterBinderTemplates(plan.PlanID);
      }
    });
   }

  getBinderTemplates() {
    this.http.get<StandardTemplate[]>(this.BASEURL+'/binders').subscribe(templates => {
      console.log('binder templates:', templates);
      this.binderTemplates.set(templates);
    });
  }

  getOpsTemplates() {
    this.http.get<StandardTemplate[]>(this.BASEURL+'/ops').subscribe(templates => {
      this.opsTemplates.set(templates);
      console.log('templates:', this.opsTemplates());
    });
  }

  purgePlan(planId: number, SSID: number) {
    const templates = this.opsTemplates();
    const updatedTemplates = templates.map(template => {
      if (template.SSID !== SSID && template.SSPlans) {
        return {
          ...template,
          SSPlans: template.SSPlans.filter(plan => plan.SSPlanID !== planId)
        };
      }
      return template;
    });
    
    this.opsTemplates.set(updatedTemplates);
  }

  updateTemplate(data: Partial<StandardTemplate>) {
    console.log('updating template', data);
    const template = this.selectedTemplate();
    
    if (template) {
      const updatedTemplate = { ...template, ...data };
      
      // Update templates array first
      const index = this.opsTemplates().findIndex(t => t.SSID === template.SSID);
      if (index !== -1) {
        const updatedTemplates = [
          ...this.opsTemplates().slice(0, index),
          updatedTemplate,
          ...this.opsTemplates().slice(index + 1)
        ];
        this.opsTemplates.set(updatedTemplates);
        
        // Update selected template after updating templates array
        this.selectedTemplate.set({ ...template, ...data });
      }
    }
  }

  setFIDFilter(franchise: Franchise) {
    this.officeFilter.set(franchise);
    this.filterTemplates();
    this.filterBinderTemplates(this.plansService.selectedPlan()?.PlanID || 0);
  }

  setBinderFilter(franchise: Franchise) {
    this.officeFilter.set(franchise);
    this.filterBinderTemplates(this.plansService.selectedPlan()?.PlanID || 0);
  }

  clearSelectedTemplate() {
    this.selectedTemplate.set(null);
  }

  updateTemplateAssembly(assembly: Assembly) {
    const template = this.selectedTemplate();
    if (template) {
      const index = template.StandardAssemblies.findIndex(sa => sa.AID === assembly.AID);
      if (index !== -1) {
        template.StandardAssemblies[index].Assemblies = assembly;
        
        // Update the template in the templates array
        const templateIndex = this.opsTemplates().findIndex(t => t.SSID === template.SSID);
        if (templateIndex !== -1) {
          const updatedTemplates = [...this.opsTemplates()];
          updatedTemplates[templateIndex] = template;
          this.opsTemplates.set(updatedTemplates);
        }
      }
    }
  }

  private filterTemplates() {
    if(this.officeFilter()) {
    const filter = this.officeFilter()?.Standards_FID || this.officeFilter()?.FID;
    this.filteredOpsTemplates.set(this.opsTemplates().filter(template => template.FID === filter));
    console.log('filtered templates', this.filteredOpsTemplates());
    }
    else {
      this.filteredOpsTemplates.set([]);
    }
  }

  private filterBinderTemplates(planId: number, forceSelect: boolean = false) {
    if(this.officeFilter()) {
      const filter = this.officeFilter()?.Standards_FID || this.officeFilter()?.FID;
    this.filteredBinderTemplates.set(this.binderTemplates().filter(template => template.FID === filter));
  }
  else {
    this.filteredBinderTemplates.set([]);
  }
    // Only auto-select template if no template is currently selected or if forced
    if (!this.selectedTemplate() || forceSelect) {
      this.selectedTemplate.set(this.filteredBinderTemplates().find(template => template.SSPlans.some(plan => plan.PlanID === planId)) || null);
    }
  }

  //-----api endpoints-----

  createTemplate(templateName: string, templateFID: number) {
    return this.http.post<StandardTemplate>(this.BASEURL, { description: templateName, fid: templateFID })
      .pipe(
        tap((template: StandardTemplate) => {
          this.opsTemplates.set([...this.opsTemplates(), template]);
          this.selectedTemplate.set(template);
        })
      );
  }
}
